namespace Nobox {
    export interface DashboardFormRequest {
        Tahun?: string;
    }
}
